import { FILTER_ACTIONS } from 'src/reducers/reducerConstants'
import { POLICY_TYPE_ALL } from 'src/utils/constants/common'

const initialState = {
  year: '',
  insuranceType: {
    policyType: POLICY_TYPE_ALL,
  },
  subType: '',
  selectedInsurance: {},
  clearState: false,
}

const expiredFilterParamsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FILTER_ACTIONS?.SET_YEAR:
      return { ...state, year: action.payload }

    case FILTER_ACTIONS?.SET_POLICY_TYPE:
      return {
        ...state,
        insuranceType: {
          ...state.insuranceType,
          policyType: action.payload ?? state.insuranceType.policyType,
        },
      }

    case FILTER_ACTIONS?.SET_SUB_TYPE:
      return { ...state, subType: action.payload ?? state.subType }

    case FILTER_ACTIONS?.SET_SELECTED_INSURANCE:
      return {
        ...state,
        selectedInsurance: action.payload ?? state.selectedInsurance,
      }

    case FILTER_ACTIONS?.RESET_FILTERS:
      return initialState

    case FILTER_ACTIONS?.SET_CLEAR_STATE:
      return {
        ...state,
        clearState: action.payload ?? state.clearState,
      }

    default:
      return state
  }
}

export default expiredFilterParamsReducer
